"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var FlagButtonWrapper = function FlagButtonWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showModal", _descriptor, _this);
      _initializerDefineProperty(_this, "selectedReason", _descriptor2, _this);
      _initializerDefineProperty(_this, "otherText", _descriptor3, _this);
      _this.handleReasonSelect = function (reason) {
        if (_this.selectedReason === reason) {
          _this.selectedReason = null;
          if (reason === 'Other') {
            _this.otherText = '';
          }
        } else {
          _this.selectedReason = reason;
          if (reason !== 'Other') {
            _this.otherText = '';
          }
        }
      };
      _this.flagTranslation = function (reason) {
        if (!_this.props.translationSource) return;
        var translation = _this.props.translationSource;
        translation.flaggedForRetranslation = !translation.flaggedForRetranslation;
        var updateData = {
          flaggedForRetranslation: translation.flaggedForRetranslation
        };
        if (reason) {
          updateData.flaggingReason = reason;
        }
        _state.AppUI.translationSourceStore.update({
          ids: {
            translationSourceId: translation.id
          },
          data: updateData
        }, _this.afterFlag);
      };
      _this.afterFlag = function () {
        if (_this.props.onAfterFlag) {
          _this.props.onAfterFlag();
        }
      };
      _this.onConfirm = function () {
        if (_this.props.translationSource) {
          _this.flagTranslation();
        }
      };
      _this.handleConfirmReason = function () {
        var reason = _this.selectedReason;
        if (reason === 'Other' && _this.otherText.trim()) {
          reason = _this.otherText.trim().substring(0, _this.otherInputMaxLength);
        }
        _this.showModal = false;
        _this.selectedReason = null;
        _this.otherText = '';
        if (reason) {
          var _this$props$translati;
          _state.DeckUI.createEvent('deck - report translation', {
            translation_source_id: (_this$props$translati = _this.props.translationSource) === null || _this$props$translati === void 0 ? void 0 : _this$props$translati.id,
            flagging_reason: reason
          });
          _this.flagTranslation(reason);
        }
        if (_this.props.onAfterConfirmReason) {
          _this.props.onAfterConfirmReason();
        }
      };
      _this.handleCancelModal = function () {
        _this.showModal = false;
        _this.selectedReason = null;
        _this.otherText = '';
        if (_this.props.onAfterCancelModal) {
          _this.props.onAfterCancelModal();
        }
      };
      _this.handlePress = function () {
        if (_this.isFlagged) {
          if (_this.showRemoveFlaggingAlertRef) {
            _this.showRemoveFlaggingAlertRef(_this.removeFlaggingTitle, _this.removeFlaggingMessage, _this.onConfirm);
          }
        } else {
          _this.showModal = true;
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "reasons",
      get: function get() {
        var _this$props$word, _this$props$word2, _this$props$word3;
        var maxLength = _state.AppUI.layout.isNative ? 20 : 30;
        var targetText = (0, _utils.truncateAtWordBoundary)(((_this$props$word = this.props.word) === null || _this$props$word === void 0 ? void 0 : _this$props$word.targetText) || '', maxLength);
        var wordTypeName = ((_this$props$word2 = this.props.word) === null || _this$props$word2 === void 0 || (_this$props$word2 = _this$props$word2.wordType) === null || _this$props$word2 === void 0 ? void 0 : _this$props$word2.name) || ((_this$props$word3 = this.props.word) === null || _this$props$word3 === void 0 ? void 0 : _this$props$word3.wordTypeName) || '';
        var invalidTranslationText = targetText ? 'It isn\'t a valid translation of "' + targetText + '".' : 'It isn\'t a valid translation.';
        var wrongWordTypeText = wordTypeName ? "It's not a" + ('AEIOU'.includes(wordTypeName.charAt(0)) ? 'n' : '') + ' ' + wordTypeName.toLowerCase() + '.' : 'It\'s the wrong word type.';
        return ['It has a spelling or grammar mistake.', invalidTranslationText, wrongWordTypeText, 'It\'s not the correct language.', 'It appears several times in the list of translations.', 'Other'];
      }
    }, {
      key: "isFlagged",
      get: function get() {
        return this.props.flagged || this.props.translationSource && this.props.translationSource.flaggedForRetranslation;
      }
    }, {
      key: "canConfirm",
      get: function get() {
        if (!this.selectedReason) return false;
        if (this.selectedReason === 'Other') {
          return this.otherText.trim().length > 0;
        }
        return true;
      }
    }, {
      key: "modalTitle",
      get: function get() {
        return 'Report this Translation';
      }
    }, {
      key: "questionText",
      get: function get() {
        var _this$props$translati2, _this$props$word4;
        var translationText = (0, _utils.truncateAtWordBoundary)(((_this$props$translati2 = this.props.translationSource) === null || _this$props$translati2 === void 0 || (_this$props$translati2 = _this$props$translati2.source) === null || _this$props$translati2 === void 0 ? void 0 : _this$props$translati2.text) || '', 30);
        var targetText = (0, _utils.truncateAtWordBoundary)(((_this$props$word4 = this.props.word) === null || _this$props$word4 === void 0 ? void 0 : _this$props$word4.targetText) || '', 30);
        return "What's wrong with the translation \"".concat(translationText, "\" for \"").concat(targetText, "\"?");
      }
    }, {
      key: "removeFlaggingTitle",
      get: function get() {
        return 'Remove Flagging';
      }
    }, {
      key: "removeFlaggingMessage",
      get: function get() {
        return 'Remove Flagging of this Translation?';
      }
    }, {
      key: "cancelButtonText",
      get: function get() {
        return 'Cancel';
      }
    }, {
      key: "removeButtonText",
      get: function get() {
        return 'Remove';
      }
    }, {
      key: "confirmButtonText",
      get: function get() {
        return 'Confirm';
      }
    }, {
      key: "otherInputPlaceholder",
      get: function get() {
        return 'Please specify (max 100 characters)';
      }
    }, {
      key: "otherInputMaxLength",
      get: function get() {
        return 100;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showModal: this.showModal,
          selectedReason: this.selectedReason,
          otherText: this.otherText,
          reasons: this.reasons,
          isFlagged: this.isFlagged,
          canConfirm: this.canConfirm,
          modalTitle: this.modalTitle,
          questionText: this.questionText,
          removeFlaggingTitle: this.removeFlaggingTitle,
          removeFlaggingMessage: this.removeFlaggingMessage,
          cancelButtonText: this.cancelButtonText,
          removeButtonText: this.removeButtonText,
          confirmButtonText: this.confirmButtonText,
          otherInputPlaceholder: this.otherInputPlaceholder,
          otherInputMaxLength: this.otherInputMaxLength,
          onReasonSelect: this.handleReasonSelect,
          onOtherTextChange: function onOtherTextChange(text) {
            return _this2.otherText = text;
          },
          onConfirmReason: this.handleConfirmReason,
          onCancelModal: this.handleCancelModal,
          onPress: this.handlePress,
          onConfirm: this.onConfirm,
          setShowRemoveFlaggingAlertRef: function setShowRemoveFlaggingAlertRef(ref) {
            return _this2.showRemoveFlaggingAlertRef = ref;
          }
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedReason", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "otherText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "reasons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reasons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFlagged", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFlagged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canConfirm", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canConfirm"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "modalTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "modalTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "questionText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "questionText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeFlaggingTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "removeFlaggingTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeFlaggingMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "removeFlaggingMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancelButtonText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cancelButtonText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeButtonText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "removeButtonText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "confirmButtonText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "confirmButtonText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "otherInputPlaceholder", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "otherInputPlaceholder"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "otherInputMaxLength", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "otherInputMaxLength"), _class2.prototype), _class2)) || _class;
};
FlagButtonWrapper.displayName = 'FlagButtonWrapper';
var _default = exports["default"] = FlagButtonWrapper;